import React from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import TopSearch from "./TopSearch";
import CardList from "./CardList";

const ShopPage = () => {
  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />
      <main className="flex-1 p-6 pl-8">
        <LeftResponsivesidebar />
        <Headmenu />

        {/* Carousel and Product cards section */}
        <div className="">
          <TopSearch />
          <CardList />
        </div>
      </main>
    </div>
  );
};

export default ShopPage;
